export default "__VITE_ASSET__DKTYWvoe__"